import { Avatar, Box, Button, Flex, Menu, MenuButton, MenuItem, MenuList, Portal, Text, useColorModeValue, } from '@chakra-ui/react';
import Usa from 'assets/img/dashboards/usa.png';
import PropTypes from 'prop-types';
import React from 'react';
import { AuthContext } from "context";
import { useContext, useState, useEffect } from "react";
import { hasModulePermission } from 'utils/modulePermissions';
import CampanaNotificaciones from './CampanaNotificaciones';
import ChatInterno from 'components/chat/ChatInterno';
import CalendarioNavbar from './CalendarioNavbar';
import BotonModoNoche from './BotonModoNoche';
import { MdSupportAgent } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';


export default function HeaderLinks(props) {
  const { secondary } = props;
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const shadow = useColorModeValue('14px 17px 40px 4px rgba(112, 144, 176, 0.18)', '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',);
  const trmBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const trmBorder = useColorModeValue('gray.200', 'whiteAlpha.300');
  const trmLabel = useColorModeValue('gray.500', 'gray.300');
  const authContext = useContext(AuthContext);
  const [trm, setTrm] = useState("");
  const navigate = useNavigate();

  // El calendario muestra actividades: sin ese módulo no hay nada que ver.
  const conCalendario = hasModulePermission(authContext?.user, 'actividades');

  useEffect(() => {
    const getDataTRM = async () => {
      try {
        const res = await fetch("https://co.dolarapi.com/v1/trm");
        const data = await res.json();
        setTrm(data.valor);
      } catch (e) {
        console.error("Error al obtener la TRM:", e);
      }
    };

    getDataTRM();
  }, []);

  let NombreCompleto = ''
  let ApellidoCompleto = ''

  if (authContext.user) {
    NombreCompleto = authContext.user.USU_CNOMBRECOMPLETO
    ApellidoCompleto = authContext.user.USU_CAPELLIDOCOMPLETO
  }

  const CerrarSesion = () => {
    authContext.logout();
  }


  return (
    <Flex
      w={{ base: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      justifyContent={{ base: "space-between", md: "flex-start" }}
      bg={menuBg}
      flexWrap={{ base: 'wrap', md: secondary ? 'wrap' : 'nowrap', xl: 'nowrap' }}
      p={{ base: "8px", md: "10px" }}
      borderRadius="30px"
      boxShadow={shadow}
      gap={{ base: "8px", md: "10px" }}>
      <Flex
        display={{ base: 'none', xl: 'flex' }}
        align='center'
        bg={trmBg}
        border='1px solid'
        borderColor={trmBorder}
        borderRadius='30px'
        px='12px'
        py='6px'
        me={{ base: '0px', md: '6px' }}
        minW='220px'
      >
        <Avatar size='xs' src={Usa} me='8px' />
        <Box>
          <Text fontSize='xs' color={trmLabel} lineHeight='1.1'>
            TRM (USD → COP)
          </Text>
          <Text fontSize='sm' fontWeight='700' color={textColor} lineHeight='1.2'>
            {trm ? `COP ${trm}` : '--'}
          </Text>
        </Box>
      </Flex>

      <Flex align="center" gap={{ base: "2px", md: "4px" }} me={{ base: "0px", md: "4px" }}>
        <BotonModoNoche />
        {conCalendario && <CalendarioNavbar />}
        <ChatInterno />
        <CampanaNotificaciones />
      </Flex>

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color="white"
            name={NombreCompleto + ' ' + ApellidoCompleto}
            bg="brand.500"
            size={{ base: "xs", md: "sm" }}
            w={{ base: "32px", md: "40px" }}
            h={{ base: "32px", md: "40px" }}
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          w={{ base: "calc(100vw - 24px)", md: "auto" }}
          maxW={{ base: "calc(100vw - 24px)", md: "none" }}>
          <Flex w="100%" mb="0px">
            <Text
              ps={{ base: "15px", md: "20px" }}
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize={{ base: "xs", md: "sm" }}
              fontWeight="700"
              color={textColor}
              noOfLines={1}>
              👋&nbsp; {NombreCompleto + ' ' + ApellidoCompleto}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={CerrarSesion}>
              <Text fontSize={{ base: "xs", md: "sm" }}>Cerrar Sesion</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
      <Portal>
        <Button
          leftIcon={<MdSupportAgent size="22px" />}
          colorScheme="blue"
          onClick={() => navigate('/admin/Crear_Ticket')}
          position="fixed"
          right={{ base: "18px", md: "32px" }}
          bottom={{ base: "18px", md: "28px" }}
          zIndex={1400}
          borderRadius="full"
          px={{ base: "18px", md: "24px" }}
          h={{ base: "48px", md: "54px" }}
          boxShadow="0 10px 24px rgba(49, 130, 206, 0.38)"
          _hover={{ transform: "translateY(-2px)", boxShadow: "0 14px 28px rgba(49, 130, 206, 0.48)" }}
          transition="all 0.2s ease"
        >
          Contacta con soporte
        </Button>
      </Portal>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
